import axios from '@/libs/api.request'
// 学生反馈 - 文书
export const subExpertModifyEssay = data => {
  return axios.request({
    url: '/expert/modify/essay',
    data,
    method: 'POST'
  })
}
// 学生反馈 - CVRL
export const subExpertModifyCvRl = data => {
  return axios.request({
    url: '/expert/modify/cvrl',
    data,
    method: 'POST'
  })
}
// essays列表
export const getExpertEssays = data => {
  return axios.request({
    url: '/expert/essays',
    data,
    method: 'POST'
  })
}
// RL列表
export const getExpertRl = data => {
  return axios.request({
    url: '/expert/rl',
    data,
    method: 'POST'
  })
}
// cv列表
export const getExpertCv = data => {
  return axios.request({
    url: '/expert/cv',
    data,
    method: 'POST'
  })
}
